import { useContext } from 'react'
import { FoodProfilesContext } from './FoodProfilesContext'

export function useGetFoodProfiles() {
  const context = useContext(FoodProfilesContext)

  if (!context) {
    throw new Error('useGetFoodProfiles must be used within FoodProfilesProvider')
  }

  return context
}
